export default "__VITE_ASSET__DG063iOz__"